import { guardedClient as clientRequest } from '@repo/shared/helpers';
import { Group, Role } from '@repo/shared/domain';

export const getMyGroups = async (): Promise<Group[]> => {
	const { body } = await clientRequest.get<undefined, Group[]>('/api/supervisor-portal/groups', {
		schema: undefined,
	});
	return body;
};

export const getGroupRoles = async (groupId: string): Promise<Role[]> => {
	const { body } = await clientRequest.get<undefined, Role[]>(`/api/supervisor-portal/groups/${groupId}/roles`, {
		schema: undefined,
	});
	return body;
};
